export default {
    indexImports:   { method: 'get',    url: 'imports'},
    storeImport:    { method: 'post',   url: 'imports'},
    updateImport:   { method: 'put',    url: 'imports/{id}'},
    destroyImport:  { method: 'delete', url: 'imports/{id}'},
}